import { render, staticRenderFns } from "./shareDialogUserRow.vue?vue&type=template&id=377e5bfa&scoped=true&"
import script from "./shareDialogUserRow.vue?vue&type=script&lang=js&"
export * from "./shareDialogUserRow.vue?vue&type=script&lang=js&"
import style0 from "./shareDialogUserRow.vue?vue&type=style&index=0&id=377e5bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e5bfa",
  null
  
)

export default component.exports